import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col, Button } from 'reactstrap';

import { callApi, formatDateTime } from '../../utils';
import { showError } from '../../actions/notificationActions';
import CreatePromotionModal from '../CreatePromotionModal';

import SearchForm from '.././SearchForm';
import UserLink from '../../components/Users/UserLink';
import DataTable, { PageHeader } from '../DataTable';

class List extends Component {
  state = {
    rows: [],
    query: '',
    page: 1,
    limit: 30,
    loading: false,
    pages: 1,
  };

  componentWillMount() {
    this.load();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  load = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, page, limit } = this.state;

    this.startLoad();
    callApi(`/fraud-events?q=${query}&page=${page}&limit=${limit}`)
      .then(({ data = [], meta = {} }) => {
        this.setState({ loading: false, rows: data, pages: meta.pages });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.load();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  refresh = () => {
    window.location.reload();
  };

  resolve = (row) => {
    callApi(
      `/fraud-events/${row.id}`,
      {
        status: 'CLOSED',
      },
      'PATCH'
    )
      .then(() => {
        this.load();
      })
      .catch((err) => {
        this.props.dispatch(showError(err));
      });
  };

  render() {
    const { query, rows, page, loading, limit, pages } = this.state;

    const hasResults = rows.length > 0;
    return (
      <div className="container-fluid">
        <CreatePromotionModal refresh={this.refresh} />

        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="Fraud Events"
              subtitle={<>Fraud Events - Page {page}</>}
            >
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.load}
                loading={loading}
              />
            </PageHeader>

            <DataTable
              minWidth={800}
              loading={loading}
              page={page}
              total={pages || 1}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Type</th>
                  <th>Notes</th>
                  <th>User</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((t, i) => (
                  <tr key={t.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{t.type}</td>
                    <td>{t.notes}</td>
                    <td>
                      {t.user ? (
                        <UserLink user={t.user}>
                          {t.user.name || t.user.email || 'N/A'}
                        </UserLink>
                      ) : (
                        'N/A'
                      )}
                    </td>
                    <td>{t.status}</td>
                    <td>{formatDateTime(t.created_at)}</td>
                    <td>
                      <Button
                        disabled={t.status === 'CLOSED'}
                        size="sm"
                        onClick={() => {
                          this.resolve(t);
                        }}
                      >
                        Resolve
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(List);
